const ENV_NAME = import.meta.env.MODE;
const CLIENT_ID = import.meta.env.VITE_OKTA_CLIENT_ID;
const ISSUER = import.meta.env?.VITE_OKTA_ISSUER;
const VITE_OKTA_TESTING_DISABLEHTTPSCHECK = import.meta.env.VITE_OKTA_TESTING_DISABLEHTTPSCHECK || false;
const BASENAME = import.meta.env.VITE_BASE_URL;
const REDIRECT_URI = `${window.location.origin}/login/callback`;

const VITE_K12_CHAT_URL = import.meta.env.VITE_K12_CHAT_URL;
const POST_LOGOUT_REDIRECT_URI = import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI;
const VITE_HEAP_APP_ID = import.meta.env.VITE_HEAP_APP_ID;
const VITE_WP_BASE_API_URL= import.meta.env.VITE_WP_BASE_API_URL;
const VITE_VWO_ACCOUNT_ID= import.meta.env.VITE_VWO_ACCOUNT_ID;
const VITE_CANVAS_URL = import.meta.env.VITE_CANVAS_URL;
const VITE_HELP_CENTER_URL = import.meta.env.VITE_HELP_CENTER_URL;

// BASE URL & Application School Information Links 
const ORIGIN_BASE_URL = window.location.origin;
const ROUTES = {    
    ABOUT_ATTENDING_SCHOOL: `${ORIGIN_BASE_URL}/schoolinfo/about-attending-school`,
    NAVIGATE_OLS: `${ORIGIN_BASE_URL}/schoolinfo/navigating-k12-school`,
    LEARNING_ROLE_COACH: `${ORIGIN_BASE_URL}/schoolinfo/being-learning-coach`,
    SCHOOL_START_FAQ: `${ORIGIN_BASE_URL}/schoolinfo/school-start-faqs/`,
};
// BACKEND API URLs
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const API_BASE_TASK_URL = import.meta.env.VITE_API_BASE_V2_URL;
const API_ENDPOINTS = {
    USER_INFO: `${API_BASE_URL}/user`,
    TOOL_SETTINGS_STATUS: (schoolId: string, roleId: string) =>
        `${API_BASE_URL}/toolsettings/school/${schoolId}/role/${roleId}`,
    QUICKLINKS: `${API_BASE_URL}/quicklinks`,
    STUDENT_PROGRAM_INFO: (id: string) => `${API_BASE_URL}/user/student/${id}/program`,
	WP_SINGLE_SCHOOL_API:`${VITE_WP_BASE_API_URL}/onboardings`,
    WP_ALL_SCHOOL_API:`${VITE_WP_BASE_API_URL}/onboardings`,
    SHIPPING_DETAILS: (identityId: string) => 
        `${API_BASE_URL}/shipping/${identityId}`,
    ACKNOWLEDGEMENT: (schoolId: string, schoolShortName: string) =>
        `${API_BASE_URL}/acknowledgement?schoolId=${
            schoolId}&schoolShortName=${schoolShortName}`,
    TASKS: (identityId: string) =>
        `${API_BASE_TASK_URL}/tasks?identityId=${encodeURIComponent(identityId)}`,
    /** v2 school-link — default portal resolution for in-app pages. */
    QUICKLINKS_SCHOOL_LINK: `${API_BASE_TASK_URL}/quicklinks/school-link`,
    /** v1 canvas quicklink — used when `/milestone-1` is accessed directly. */
    QUICKLINKS_CANVAS: `${API_BASE_URL}/quicklinks/canvas`,
};
// External Portals Links
const LINKS = {
    COMMUNITY_URL: import.meta.env.VITE_COMMUNITY_URL,
    K12Zone_URL: import.meta.env.VITE_K12ZONE_URL,
    CONSENT_URL: import.meta.env.VITE_CONSENT_URL,
    ENROLLMENT_PORTAL: import.meta.env.VITE_ENROLLMENT_PORTAL_URL,
    APPLYNOW_PORTAL: import.meta.env.VITE_SALESFORCE_PORTAL_URL,
};
// Private School IDs 
const PRIVATE_SCHOOL_IDS = [
    "23266", "15006", "4782", "21067", "2680",
    "7135", "2700", "3227", "23566", "19766"
];

// Shipping Tracking Links 
const TRACKING_LINKS = {
    UPS: "https://www.ups.com/track?loc=en_US&tracknum=",
    USPS: "https://tools.usps.com/go/TrackConfirmAction_input?tLabels=",
    FedEx: "https://www.fedex.com/fedextrack/?trknbr="
};

// Export Configuration
export default {
    ENV_NAME,
    LINKS,
	TRACKING_LINKS,
    HELP_CENTER_URL: VITE_HELP_CENTER_URL,
    CHAT_URL: VITE_K12_CHAT_URL,
    CANVAS_URL_PARAM: VITE_CANVAS_URL,
    HEAP_APP_ID : VITE_HEAP_APP_ID,
    VWO_ACCOUNT_ID : VITE_VWO_ACCOUNT_ID,
    oidc: {
        clientId: CLIENT_ID,
        issuer: ISSUER,
        redirectUri: REDIRECT_URI,
        postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI,
        scopes: ["openid", "profile", "email"],
        pkce: true,
        dpop: true,
        disableHttpsCheck: VITE_OKTA_TESTING_DISABLEHTTPSCHECK,
    },
    app: {
        baseUrl: ORIGIN_BASE_URL,
        routes: ROUTES,
        privateSchoolIds: PRIVATE_SCHOOL_IDS
    },
    api: {
        baseUrl: API_BASE_URL,
        taskCompletionBaseUrl: API_BASE_TASK_URL,
        endpoints: API_ENDPOINTS,
    },
};
